import { formatMontant } from '@mairistem/finances-utils';

const formatMontantWithOperator = (
	montant: number,
	percent: boolean = false,
	devise: boolean = false,
) => {
	const operator = montant >= 0 ? '+' : '-';
	return `${operator} ${formatMontant(Math.abs(montant), 2, devise, '', percent)}`;
};

export default formatMontantWithOperator;
